var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  Adapter library for IPFS, so the rest of the business logic doesn't need to
  know specifics about the IPFS API.
*/
// The amount of time to wait to connect to a peer, in milliseconds.
// Increasing the time makes the network slower but more resilient to latency.
// Decreasing the time makes the network faster, but more smaller and more fragile.
var CONNECTION_TIMEOUT = 10000;

var bootstapNodes = require('../../config/bootstrap-circuit-relays');

var IpfsAdapter = /*#__PURE__*/function () {
  "use strict";

  function IpfsAdapter() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, IpfsAdapter);

    // Input Validation
    this.ipfs = localConfig.ipfs;

    if (!this.ipfs) {
      throw new Error('An instance of IPFS must be passed when instantiating the IPFS adapter library.');
    }

    this.log = localConfig.log;

    if (!this.log) {
      throw new Error('A status log handler must be specified when instantiating IPFS adapter library.');
    } // 'embedded' node type used as default, will use embedded js-ipfs.
    // Alternative is 'external' which will use ipfs-http-client to control an
    // external IPFS node.


    this.nodeType = localConfig.nodeType;

    if (!this.nodeType) {
      // console.log('No node type specified. Assuming embedded js-ipfs.')
      this.nodeType = 'embedded';
    } // Placeholders that will be filled in after the node finishes initializing.


    this.ipfsPeerId = '';
    this.ipfsMultiaddrs = '';
  } // Start the IPFS node if it hasn't already been started.
  // Update the state of this adapter with the IPFS node information.


  _createClass(IpfsAdapter, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var id2, addrs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.ipfs;

              case 3:
                this.ipfs = _context.sent;
                _context.next = 6;
                return this.ipfs.id();

              case 6:
                id2 = _context.sent;
                // this.state.ipfsPeerId = id2.id
                this.ipfsPeerId = id2.id; // Get multiaddrs that can be used to connect to this node.

                addrs = id2.addresses.map(function (elem) {
                  return elem.toString();
                }); // this.state.ipfsMultiaddrs = addrs

                this.ipfsMultiaddrs = addrs; // Remove bootstrap nodes, as we have our own bootstrap nodes, and the
                // the default ones can spam our nodes with a ton of bandwidth.

                _context.next = 12;
                return this.ipfs.config.set('Bootstrap', [bootstapNodes.node[0].multiaddr, bootstapNodes.node[1].multiaddr]);

              case 12:
                if (!(this.nodeType === 'embedded')) {
                  _context.next = 15;
                  break;
                }

                _context.next = 15;
                return this.ipfs.config.set('Addresses.Delegates', []);

              case 15:
                if (!(this.nodeType === 'external')) {
                  _context.next = 20;
                  break;
                }

                _context.next = 18;
                return this.ipfs.config.set('Swarm.RelayClient.Enabled', true);

              case 18:
                _context.next = 20;
                return this.ipfs.config.set('Swarm.EnableHolePunching', true);

              case 20:
                _context.next = 22;
                return this.ipfs.config.set('preload.enabled', false);

              case 22:
                _context.next = 24;
                return this.ipfs.config.set('Swarm.ConnMgr', {
                  LowWater: 10,
                  HighWater: 30
                });

              case 24:
                _context.next = 26;
                return this.ipfs.config.set('Datastore.StorageMax', '2GB');

              case 26:
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](0);
                console.error('Error in ipfs-adapter.js/start()');
                throw _context.t0;

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 28]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }() // Attempts to connect to an IPFS peer, given its IPFS multiaddr.
    // Returns true if the connection succeeded. Otherwise returns false.

  }, {
    key: "connectToPeer",
    value: function () {
      var _connectToPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ipfsAddr) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.ipfs.swarm.connect(ipfsAddr, {
                  timeout: CONNECTION_TIMEOUT
                });

              case 3:
                // if (this.debugLevel) {
                //   this.statusLog(
                //     `status: Successfully connected to peer node ${ipfsAddr}`
                //   )
                // }
                this.log.statusLog(1, "Successfully connected to peer node ".concat(ipfsAddr));
                return _context2.abrupt("return", true);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                /* exit quietly */
                // console.warn(
                //   `Error trying to connect to peer node ${ipfsId}: ${err.message}`
                // )
                // if (this.debugLevel === 1) {
                //   this.statusLog(
                //     `status: Error trying to connect to peer node ${ipfsAddr}`
                //   )
                // } else if (this.debugLevel === 2) {
                //   this.statusLog(
                //     `status: Error trying to connect to peer node ${ipfsAddr}: `,
                //     err
                //   )
                // }
                this.log.statusLog(2, "Error trying to connect to peer node ".concat(ipfsAddr)); // console.log(`Error trying to connect to peer node ${ipfsAddr}: `, err)
                // this.log.statusLog(
                //   3,
                //   `Error trying to connect to peer node ${ipfsAddr}: `,
                //   err
                // )

                return _context2.abrupt("return", false);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function connectToPeer(_x) {
        return _connectToPeer.apply(this, arguments);
      }

      return connectToPeer;
    }() // Disconnect from a peer.

  }, {
    key: "disconnectFromPeer",
    value: function () {
      var _disconnectFromPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ipfsId) {
        var connectedPeers, connectedPeer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.getPeers();

              case 3:
                connectedPeers = _context3.sent;
                // console.log('connectedPeers: ', connectedPeers)
                // See if we're connected to the given IPFS ID
                connectedPeer = connectedPeers.filter(function (x) {
                  return x.peer === ipfsId;
                }); // If we're not connected, exit.

                if (connectedPeer.length) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", true);

              case 7:
                _context3.next = 9;
                return this.ipfs.swarm.disconnect(connectedPeer[0].addr, {
                  timeout: CONNECTION_TIMEOUT
                });

              case 9:
                return _context3.abrupt("return", true);

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", false);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 12]]);
      }));

      function disconnectFromPeer(_x2) {
        return _disconnectFromPeer.apply(this, arguments);
      }

      return disconnectFromPeer;
    }()
  }, {
    key: "disconnectFromMultiaddr",
    value: function () {
      var _disconnectFromMultiaddr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(multiaddr) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.ipfs.swarm.disconnect(multiaddr, {
                  timeout: CONNECTION_TIMEOUT
                });

              case 3:
                return _context4.abrupt("return", true);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", false);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6]]);
      }));

      function disconnectFromMultiaddr(_x3) {
        return _disconnectFromMultiaddr.apply(this, arguments);
      }

      return disconnectFromMultiaddr;
    }() // Get a list of all the IPFS peers This Node is connected to.

  }, {
    key: "getPeers",
    value: function () {
      var _getPeers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var connectedPeers;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.ipfs.swarm.peers({
                  direction: true,
                  streams: true,
                  verbose: true,
                  latency: true
                });

              case 3:
                connectedPeers = _context5.sent;
                return _context5.abrupt("return", connectedPeers);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                console.error('Error in ipfs-adapter.js/getPeers()');
                throw _context5.t0;

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function getPeers() {
        return _getPeers.apply(this, arguments);
      }

      return getPeers;
    }()
  }]);

  return IpfsAdapter;
}();

module.exports = IpfsAdapter;